import { memo } from "react";
import { shiftManagerTabs } from "../../../consts/tabs";

import { SectionMenu } from "../components/SectionMenu";
import { ShiftManagerDetail } from "../../ShiftManagerDetail";

export const ShiftManagerManagementSections = memo(() => {
  return (
    <SectionMenu tabs={shiftManagerTabs}>
      <SectionMenu.SectionMenuItem id={0}>
        <ShiftManagerDetail />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
